import { $Q } from "../utils/query-selector";

/**
 * Capture the button to change the page of register to login
 */

export const loginPage = () => {
  const recoverCta = $Q(".login-session--field-recover");
  
  if( recoverCta != null) {
    const recoverSection = $Q(".login-recover");
    const loginSection = $Q(".login-session");
    const cancelCta = $Q(".login-recover--cancel");

    recoverPassword(recoverCta, recoverSection, loginSection);
    recoverPassword(cancelCta, recoverSection, loginSection);
    readRestarInput(recoverSection, loginSection)
  }
}

const recoverPassword = (element, recoverSection, loginSection) => {
  element.addEventListener("click", ()=> {
    recoverSection.classList.toggle("hidden");
    loginSection.classList.toggle("hidden");
  })
}

const readRestarInput = (recoverSection, loginSection) => {
  const recoverEmail = $Q('#RecoverEmail')

  if ( recoverEmail.dataset.invalid == 'true' ){
    recoverSection.classList.toggle("hidden");
    loginSection.classList.toggle("hidden");
  }
}

